<template>
    <div class="root">
        <v-btn block large
            v-if="!$store.state.user"
            :disabled="isOffline"
            :to="{name:'login'}"
            color="primary"
        >
            {{$vuetify.t('$vuetify.home.login')}}
        </v-btn>

        <v-btn block large
               v-if="!$store.state.user"
               :disabled="isOffline"
               @click="startTestScanner"
               color="success"
        >
            {{$vuetify.t('$vuetify.menu.test')}}
        </v-btn>

        <v-btn block large
               v-if="$store.state.user && $store.state.tickets.length"
               @click="routeToScanner"
               color="primary"
        >
            {{$vuetify.t('$vuetify.home.lastEvent')}}
        </v-btn>

        <v-btn block large
            v-if="$store.state.user"
            :disabled="isOffline"
            :to="{name:'events'}"
               color="success"
        >
            {{$vuetify.t('$vuetify.home.chooseEvent')}}
        </v-btn>

        <br />
        <v-img
            :src="require('../assets/logo-home-bzuco.png')"
            contain
            height="115"
            class="mt-5 mb-5"
        ></v-img>

        <br />
        <h1 class="text-center">Inspector</h1>
    </div>
</template>

<script>
    import {initSound} from '../libs/utils'

    export default {
        name: 'home',

        data() {
            return {
            }
        },

        computed: {
            getEnv () {
                return process.env.VUE_APP_ENV
            }
        },

        methods: {
            routeToScanner () {
                initSound(this.$store)
                this.$router.push({name:'scanner'})
            },
            startTestScanner() {
                initSound(this.$store)
                this.$router.push({name:'test-scanner'})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .full {
        display: block;
    }
    .text-center {
        text-align: center;
    }
    .qr {
        margin: 0 auto;
    }
</style>
